import React from 'react'
import styled from 'styled-components';
import GrantItem from './GrantItem'
import {maxWidth} from '../common/StyleValue'

const GrantboxStyle = styled.div`
  margin: 50px auto;
  width: ${maxWidth}px;
  background-color: #fff;
  @media (max-width: 768px) {
    width: calc(100% - 40px);
    margin-left: 20px;
  }
`;

export default function Startgrant() {
  return (
    <GrantboxStyle>
      <GrantItem></GrantItem>
    </GrantboxStyle>
  )
}
